import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import MyBookingsPage from "../../../bookings/MyBookingsPage.tsx";

export const Route = createFileRoute('/_app/courts-booking/$')({
    component: RouteComponent,
})

/** My Bookings: confirmation after a booking, upcoming and past cards, cancel with refund, and the Book a court list. */
function RouteComponent() {
    return <MyBookingsPage />;
}
